import { useState } from "react";
import Camera, { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import CameraswitchIcon from "@mui/icons-material/Cameraswitch";
import { Box, Button, Typography, Stack } from "@mui/material";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import "react-html5-camera-photo-patched/build/css/index.css";
import CloseIcon from "@mui/icons-material/Close";

export default function TCamera({
  photoDataUri,
  setPhotoDataUri,
  disabled,
  onClose,
  ismetaForm = false,
}) {
  const [openCamera, setOpenCamera] = useState(false);
  const [idealFacingMode, setIdealFacingMode] = useState(
    FACING_MODES.ENVIRONMENT
  );
  const isFullscreen = false;
  const rowsx = {
    display: "flex",
    justifyContent: "center",
    bgcolor: "background.paper",
  };

  const handleTakePhotoAnimationDone = (dataUri) => {
    setPhotoDataUri(dataUri);
    setOpenCamera(false);

    // Convert base64 to blob
    const byteString = atob(dataUri.split(',')[1]);
    const mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([ab], { type: mimeString });
    const file = new File([blob], "photo.jpg", { type: "image/jpeg" });

    if (onClose) onClose(file);
  };

  function cancel() {
    setPhotoDataUri("");
    setOpenCamera(false);
    if (onClose) onClose(null);
  }

  function toggleCameraMode() {
    setIdealFacingMode(
      idealFacingMode === FACING_MODES.ENVIRONMENT
        ? FACING_MODES.USER
        : FACING_MODES.ENVIRONMENT
    );
  }

  function open() {
    setPhotoDataUri("");
    setOpenCamera(true);
  }

  return (
    <Stack direction="column" spacing={1} alignItems="center">
      {openCamera === false && photoDataUri !== "" && (
        <img
          src={photoDataUri}
          alt="preview"
          style={{
            width: "100%",
            borderRadius: "2%",
            border: "3px solid gray",
          }}
        />
      )}
      {openCamera === true && (
        <>
          <Camera
            onTakePhotoAnimationDone={handleTakePhotoAnimationDone}
            isFullscreen={isFullscreen}
            imageType={IMAGE_TYPES.JPG}
            idealFacingMode={idealFacingMode}
            imageCompression={0.8}
            idealResolution={{ width: 1080, height: 720 }}
            isImageMirror={idealFacingMode !== FACING_MODES.ENVIRONMENT}
            isDisplayStartCameraError
          />

          <Box sx={rowsx}>
            <CloseIcon onClick={() => cancel()} sx={{ p: 1, m: 1 }} />
            <CameraswitchIcon
              onClick={() => toggleCameraMode()}
              sx={{ p: 1, m: 1 }}
            />
          </Box>
        </>
      )}
      {openCamera === false && (
        <Stack direction="row" alignItems="center">
          <Button
            variant="contained"
            size="small"
            sx={{
              width: 225,
              alignItems: "center",
              pt: 1,
              pb: 1,
              columnGap: 2,
              bgcolor: "rgb(25, 118, 210)",
              color: "white",
              ":hover": {
                bgcolor: "rgb(25, 118, 210)",
              }
            }}
            onClick={() => open()}
            disabled={disabled}
          >
            {!ismetaForm ? (
              <Typography variant="body2">
                {photoDataUri === "" ? <>Take a</> : <>Retake</>} Photo
              </Typography>
            ) : (
              <Typography variant="body2">
                {photoDataUri === "" ? <>Capture</> : <>Recapture</>} Docs
              </Typography>
            )}
            <AddAPhotoIcon data-testid="AddAPhotoIcon" />
          </Button>
        </Stack>
      )}
    </Stack>
  );
}
